"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entriesObject = void 0;
const entriesObject = (object) => Object.entries(object);
exports.entriesObject = entriesObject;
